import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const FaqItem = styled.div`
  padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(4)}`};

  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: ${({ theme }) => theme.spacing(3)};
  background: ${({ theme }) => theme.palette.common.white};
`;

export const FaqQuestion = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};

  width: 100%;
  padding: 0;
  margin: 0;

  border: none;
  background: none;
  cursor: pointer;

  color: ${({ theme }) => theme.palette.text.primary};
  text-align: left;
`;

export const FaqChevron = styled.span<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.text.secondary};

  transition: transform 200ms;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: rotate(180deg);
    `};
`;

export const FaqAnswer = styled.p`
  ${({ theme }) => typographyToCss(theme.typography.body1)};

  margin: ${({ theme }) => `${theme.spacing(2)} 0 0`};
  padding: 0;

  color: ${({ theme }) => theme.palette.text.secondary};
`;
